import React, { SVGProps } from 'react';

/**
 * viewBox='0 0 24 24' er den faktiske størrelsen på svg'en. De to siste veridene må være svgen sin
 * faktiske bredde og høyde. Hvis ikke vil svg'en bli strukket til å fylle hele plassen den har.
 * widt og height er satt til 100% for å fylle hele plassen den har.
 * @param props
 * @constructor
 */
interface SvgProps extends SVGProps<SVGSVGElement> {
	pathFill?: string;
	color?: string;
}

export const AkselKonfig: React.FC<SvgProps> = ({ pathFill = 'white', ...props }) => {
	return (
		<svg
			width='100%'
			height='100%'
			viewBox='0 0 16 16'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			{...props}
		>
			<g id='Ikon' clipPath='url(#clip0_922_5216)'>
				<path
					id='Vector'
					d='M14.5 8C14.5 6.27609 13.8152 4.62279 12.5962 3.40381C11.3772 2.18482 9.72391 1.5 8 1.5C6.27609 1.5 4.62279 2.18482 3.40381 3.40381C2.18482 4.62279 1.5 6.27609 1.5 8C1.5 9.72391 2.18482 11.3772 3.40381 12.5962C4.62279 13.8152 6.27609 14.5 8 14.5C9.72391 14.5 11.3772 13.8152 12.5962 12.5962C13.8152 11.3772 14.5 9.72391 14.5 8ZM0 8C0 5.87827 0.842855 3.84344 2.34315 2.34315C3.84344 0.842855 5.87827 0 8 0C10.1217 0 12.1566 0.842855 13.6569 2.34315C15.1571 3.84344 16 5.87827 16 8C16 10.1217 15.1571 12.1566 13.6569 13.6569C12.1566 15.1571 10.1217 16 8 16C5.87827 16 3.84344 15.1571 2.34315 13.6569C0.842855 12.1566 0 10.1217 0 8ZM10.5 8.02812L11.725 8.42813C11.7406 8.2875 11.75 8.14688 11.75 8.00313C11.75 7.02813 11.3781 6.14062 10.7688 5.475L10.0125 6.51875C10.3187 6.93438 10.5 7.44688 10.5 8.00313C10.5 8.0125 10.5 8.02188 10.5 8.03125V8.02812ZM10.0344 9.45312C9.72188 9.89062 9.27187 10.2219 8.74687 10.3875V11.6781C9.82187 11.4594 10.7312 10.7812 11.2594 9.85625L10.0312 9.45625L10.0344 9.45312ZM7.25 11.675V10.3844C6.72813 10.2188 6.27812 9.8875 5.96562 9.45312L4.7375 9.85312C5.2625 10.7781 6.17188 11.4563 7.24687 11.675H7.25ZM4.275 8.425L5.5 8.02812C5.5 8.01875 5.5 8.00937 5.5 8C5.5 7.44375 5.68125 6.93125 5.9875 6.51562L5.93437 6.44375L5.22813 5.47188C4.62188 6.1375 4.25 7.025 4.25 8C4.25 8.14375 4.25938 8.2875 4.275 8.425ZM7.2 5.62813C7.45 5.54375 7.71875 5.49687 8 5.49687C8.28125 5.49687 8.55 5.54375 8.8 5.62813L9.55625 4.58437C9.08125 4.36875 8.55625 4.24687 8 4.24687C7.44375 4.24687 6.91875 4.36875 6.44375 4.58437L7.15 5.5625L7.2 5.63125V5.62813ZM9 8C9 7.73478 8.89464 7.48043 8.70711 7.29289C8.51957 7.10536 8.26522 7 8 7C7.73478 7 7.48043 7.10536 7.29289 7.29289C7.10536 7.48043 7 7.73478 7 8C7 8.26522 7.10536 8.51957 7.29289 8.70711C7.48043 8.89464 7.73478 9 8 9C8.26522 9 8.51957 8.89464 8.70711 8.70711C8.89464 8.51957 9 8.26522 9 8ZM8 2.75C9.39239 2.75 10.7277 3.30312 11.7123 4.28769C12.6969 5.27225 13.25 6.60761 13.25 8C13.25 9.39239 12.6969 10.7277 11.7123 11.7123C10.7277 12.6969 9.39239 13.25 8 13.25C6.60761 13.25 5.27225 12.6969 4.28769 11.7123C3.30312 10.7277 2.75 9.39239 2.75 8C2.75 6.60761 3.30312 5.27225 4.28769 4.28769C5.27225 3.30312 6.60761 2.75 8 2.75Z'
					fill={pathFill}
				/>
			</g>
			<defs>
				<clipPath id='clip0_922_5216'>
					<rect width='16' height='16' fill={pathFill} />
				</clipPath>
			</defs>
		</svg>
	);
};
